export default __webpack_public_path__ + "media/zurb/img/events/wired/wired-thumb-a1ba4c33c50d602ab8ea0864813085eb.png";